import React, { useEffect, useRef } from 'react';
const W = 640, H = 400, K = 1.5, CX = 320, CY = 212, KY = 0.36, C = '#2EB6E8';
const RINGS = [
  { r: 175 * K, n: 84, base: 1.9 * K, op: 0.55, outline: 0.18, sw: 0.9, speed: 0.020 },
  { r: 150 * K, n: 72, base: 2.0 * K, op: 0.70, outline: 0.18, sw: 0.9, speed: -0.028 },
  { r: 125 * K, n: 60, base: 2.1 * K, op: 0.85, outline: 0.18, sw: 0.9, speed: 0.036 },
  { r: 62 * K, n: 16, base: 3.2 * K, op: 1.00, outline: 0.9, sw: 1.6, speed: -0.06 },
];
const LY = CY - 58 * K;
const place = (ring, i, phase) => {
  const t = (i / ring.n) * 2 * Math.PI + phase;
  const dd = (Math.sin(t) + 1) / 2;
  return { cx: CX + ring.r * Math.cos(t), cy: CY + ring.r * KY * Math.sin(t), r: ring.base * (0.55 + 0.75 * dd), o: ring.op * (0.35 + 0.65 * dd) };
};
export const RingsAnimated = ({ className = '' }) => {
  const dotRefs = useRef(RINGS.map((rg) => Array(rg.n).fill(null)));
  useEffect(() => {
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return undefined;
    let raf; const start = performance.now();
    const tick = (now) => {
      const s = (now - start) / 1000;
      RINGS.forEach((ring, ri) => {
        const phase = s * ring.speed * 2 * Math.PI / 6;
        dotRefs.current[ri].forEach((el, i) => {
          if (!el) return;
          const p = place(ring, i, phase);
          el.setAttribute('cx', p.cx.toFixed(2)); el.setAttribute('cy', p.cy.toFixed(2));
          el.setAttribute('r', p.r.toFixed(2)); el.setAttribute('fill-opacity', p.o.toFixed(3));
        });
      });
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);
  const label = (y, t, op = 1) => (
    <text x={CX} y={y} textAnchor="middle" fontFamily="Poppins, sans-serif" fontSize="11.5" letterSpacing="3.2" fill="#FFFFFF" fillOpacity={op}>{t}</text>
  );
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className={className} role="img" aria-label="The leader, the team and the organisation held in one record" style={{ width: '100%', height: 'auto', display: 'block' }}>
      <defs>
        <radialGradient id="rsph" cx=".38" cy=".34" r=".75">
          <stop offset="0" stopColor="#9BE2FA" /><stop offset=".45" stopColor="#2EB6E8" /><stop offset="1" stopColor="#147FB0" />
        </radialGradient>
      </defs>
      {RINGS.map((ring, ri) => (
        <g key={ri}>
          <ellipse cx={CX} cy={CY} rx={ring.r} ry={ring.r * KY} fill="none" stroke={C} strokeOpacity={ring.outline} strokeWidth={ring.sw} />
          {Array.from({ length: ring.n }).map((_, i) => {
            const p = place(ring, i, 0);
            return <circle key={i} ref={(el) => { dotRefs.current[ri][i] = el; }} cx={p.cx} cy={p.cy} r={p.r} fill={C} fillOpacity={p.o} />;
          })}
        </g>
      ))}
      <ellipse cx={CX} cy={CY} rx={22 * K} ry={22 * K * KY} fill="#020812" fillOpacity=".45" />
      <ellipse cx={CX} cy={CY} rx={26 * K} ry={26 * K * KY} fill="none" stroke="#FFFFFF" strokeOpacity=".6" strokeWidth="1.1" />
      <line x1={CX} y1={CY} x2={CX} y2={LY + 13 * K} stroke={C} strokeOpacity=".65" strokeWidth="1.1" />
      <circle cx={CX} cy={LY} r={13 * K} fill="url(#rsph)" />
      <circle cx={CX} cy={LY} r={21 * K} fill="none" stroke="#FFFFFF" strokeOpacity=".7" strokeWidth="1.1" />
      {label(LY - 21 * K - 14, 'THE LEADER')}
      {label(CY + 62 * K * KY + 18, 'THE TEAM')}
      {label(CY + 175 * K * KY + 30, 'THE ORGANISATION', 0.9)}
    </svg>
  );
};
export default RingsAnimated;
